import {getUrlQuery} from "@/utils/url";

/**
 * 判断是否是手机
 * @returns {boolean} 是否是手机
 */
export function isMobile() {
  const urlQuery = getUrlQuery();
  if (urlQuery.device) {
    return true
  } else {
    const ret = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|Wechat|MicroMessenger)/i
    ) !== null;
    return ret;
  }

}


/**
 * 判断平台
 * @returns {string} 判断平台
 */
export function getPlatform() {
  let ret = 'pc';
  if (isMobile()) {
    ret = 'mobile';
  }
  return ret;

}
